export const NAME = 'MESSAGE';
